<div class="support position-relative text-center">
  <img
    src="/assets/img/dummy-image/2560x1022.png"
    alt="Support Hero"
    class="img-fluid"
  />
  <!-- <div
    class="hero-content position-absolute top-50 start-50 translate-middle text-white text-center w-100 px-3"
    style="z-index: 2"
  >
    <h1 class="display-4 fw-bold mb-3">How Can We Help You?</h1>
    <p class="lead mb-4">
      Find answers, get support, and learn more about our services
    </p>
  </div> -->
</div>

<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6" *ngFor="let items of supportContent">
        <div class="support-card">
          <img [src]="items.image" [alt]="items.image" class="card-img" />
          <div class="support-content">
            <div class="support-description">
              <div class="support-title">
                <h2>{{ items.title }}</h2>
                <h5>{{ items.sub_title }}</h5>
              </div>
              <p>{{ items.description }}</p>
            </div>
            <button class="btn btn-outline-success mt-3">Read More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
